[
  {
    "code": "NR-01",
    "name": "Aiwo"
  },
  {
    "code": "NR-02",
    "name": "Anabar"
  },
  {
    "code": "NR-03",
    "name": "Anetan"
  },
  {
    "code": "NR-04",
    "name": "Anibare"
  },
  {
    "code": "NR-05",
    "name": "Baiti"
  },
  {
    "code": "NR-06",
    "name": "Boe"
  },
  {
    "code": "NR-07",
    "name": "Buada"
  },
  {
    "code": "NR-08",
    "name": "Denigomodu"
  },
  {
    "code": "NR-09",
    "name": "Ewa"
  },
  {
    "code": "NR-10",
    "name": "Ijuw"
  },
  {
    "code": "NR-11",
    "name": "Meneng"
  },
  {
    "code": "NR-12",
    "name": "Nibok"
  },
  {
    "code": "NR-13",
    "name": "Uaboe"
  },
  {
    "code": "NR-14",
    "name": "Yaren"
  }
]